import liquid_variables from '../utils/liquid_variables'

export function generate_menu() {
  let menu = []

  liquid_variables.forEach((category) => {
    menu.push(
      `<ul class="fr-dropdown-list" role="presentation">
        <li role="presentation">
          <a>
            <span>${ category.name }</span>
            <i class="fa fa-chevron-right"></i>
          </a>
          <ul style="list-style: none;">
            ${ generate_sub_menu(category.sub_menu) }
          </ul>
        </li>
      </ul>`
    )
  })

  return menu.join('')
}

function generate_sub_menu(sub_menu_variables) {
  let sub_menu = []

  sub_menu_variables.forEach((variable) => {
    sub_menu.push(
      `<li role="presentation">
        <a class="fr-command" role="option" data-cmd="liquid_variables" data-param1="${ variable.content }">
          <span>${ variable.name }</span>
        </a>
      </li>`
    )
  })

  return sub_menu.join('')
}
